Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.SelectType = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _useSharedStyles2 = require("../Button/Label/styles/useSharedStyles");
var SelectType = exports.SelectType = function (SelectType) {
  SelectType[SelectType["normal"] = 0] = "normal";
  SelectType[SelectType["outline"] = 1] = "outline";
  return SelectType;
}({});
var useStyles = exports.useStyles = function useStyles(_ref) {
  var type = _ref.type;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    input = _STYLES$useStyles.input,
    input_base = _STYLES$useStyles.input_base,
    boxShadows = _STYLES$useStyles.boxShadows,
    COLORS = _STYLES$useStyles.COLORS,
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular;
  var _useSharedStyles = (0, _useSharedStyles2.useSharedStyles)(),
    sharedStyles = _useSharedStyles.sharedStyles;
  var _paddingLeft = input.paddingLeft;
  var _paddingRight = input.paddingRight;
  if (type === SelectType.outline) {
    _paddingLeft = spacing.normal;
    _paddingRight = spacing.normal;
  }
  var dropdown = Object.assign({}, input, boxShadows.button.web, boxShadows.button.android, boxShadows.button.ios, _reactNative.Platform.select({
    web: {
      cursor: 'pointer'
    }
  }), {
    paddingLeft: 0,
    paddingRight: 0
  });
  if (type === SelectType.outline) {
    dropdown = Object.assign({}, dropdown, input_base, {
      borderWidth: (0, _styles.getREM)(0.125),
      borderColor: colors.brand,
      backgroundColor: colors.brandContrast,
      borderRadius: sharedStyles.label_normal.borderRadius,
      paddingLeft: 0,
      paddingRight: 0
    });
  }
  var selectedTextStyle = Object.assign({}, fontSemiBold, {
    color: input.color,
    fontSize: input.fontSize,
    lineHeight: input.height,
    paddingLeft: _paddingLeft,
    height: input.height
  });
  if (type === SelectType.outline) {
    selectedTextStyle.fontSize = sharedStyles.label_normal.fontSize;
  }
  var styles = _reactNative.StyleSheet.create({
    dropdown: dropdown,
    selectedTextStyle: selectedTextStyle,
    inputSearchStyle: {
      height: (0, _styles.getREM)(2.625),
      fontSize: _styles.STYLES.fontSize.normal,
      lineHeight: (0, _styles.getREM)(2.625 / 2),
      borderRadius: (0, _styles.getREM)(1),
      paddingLeft: spacing.xs,
      paddingRight: spacing.xs
    },
    list: Object.assign({
      alignSelf: 'stretch',
      maxWidth: input.maxWidth,
      maxHeight: (0, _styles.getREM)(15),
      backgroundColor: COLORS.paper,
      borderRadius: (0, _styles.getREM)(1.25),
      marginTop: spacing.s,
      marginBottom: spacing.s
    }, boxShadows.button.all, {
      overflow: 'hidden',
      flexShrink: 0
    }),
    listItem: Object.assign({}, fontSemiBold, {
      fontSize: _styles.STYLES.fontSize.normal,
      lineHeight: _styles.STYLES.lineHeight.normal,
      textAlign: 'left',
      color: COLORS.aubergine
    }),
    container: {
      width: '100%',
      alignItems: 'center'
    },
    placeholder: Object.assign({}, fontRegular, {
      fontSize: selectedTextStyle.fontSize,
      lineHeight: input.height,
      color: COLORS.aubergine,
      paddingLeft: _paddingLeft,
      height: input.height
    }),
    icon: {
      marginRight: _paddingRight
    }
  });
  return {
    styles: styles
  };
};